import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import UserForm from "./UserForm";
import { useGetUserByIdQuery, useUpdateUserMutation } from "../../redux/api/usersApi";
import { useGetRolesQuery } from "../../redux/api/rolesApi";

const EditUserPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  
  // Fetch user data
  const { 
    data: user, 
    isLoading: userLoading, 
    error: userError 
  } = useGetUserByIdQuery(id);
  
  // Fetch roles for the form
  const { 
    data: roles = [], 
    isLoading: rolesLoading 
  } = useGetRolesQuery();
  
  // Update mutation
  const [updateUser, { isLoading: isUpdating }] = useUpdateUserMutation();

  const handleUpdateUser = async (formData) => {
    try {
      await updateUser({ id, ...formData }).unwrap();
      toast.success('User updated successfully');
      navigate('/admin/users');
    } catch (error) {
      toast.error(error?.data?.message || error?.error || 'Failed to update user');
    }
  };

  const isLoading = userLoading || rolesLoading;

  if (isLoading) return <p>Loading...</p>;
  if (userError) return <p>Error: {userError?.data?.message || userError?.error || 'Failed to load user'}</p>;
  if (!user) return <p>User not found</p>;

  return (
    <div>
      <h1 className="mb-4">Edit User</h1>
      <UserForm 
        user={user} 
        roles={roles} 
        onSubmit={handleUpdateUser}
        loading={isUpdating}
      />
    </div>
  );
};

export default EditUserPage;
